module.exports = __webpack_public_path__ + "img/photo_220260566_1.cae13dfb.png";